import React from 'react';
import ContactForm from '../components/common/ContactForm';
import './ContactPage.css';

const expectations = [
  'An honest assessment of whether we can help.',
  'No sales pressure. If we are not the right fit we will say so.',
  'A structured discussion about the real constraint.',
  'Clear next steps, whatever the outcome.',
];

const ContactPage = () => {
  return (
    <div className="contact-page">
      {/* ===== HERO ===== */}
      <section className="ip-hero">
        <div className="ip-hero__motif" aria-hidden="true"></div>
        <div className="frame">
          <div className="ip-hero__inner">
            <div className="eyebrow-rule">I · Contact</div>
            <div className="ip-hero__wordmark">RussellStone Lighthouse</div>
            <h1 className="ip-hero__title">An honest conversation.</h1>
            <p className="ip-hero__subcap">
              No sales pitch. A structured discussion about your situation and whether what we do fits it.
            </p>
            <p className="ip-hero__lede">
              Tell us what you are dealing with. What is keeping you up at night. We respond within 24 hours with an honest assessment of whether we can help.
            </p>
          </div>
        </div>
        <div className="ip-hero__horizon" aria-hidden="true"></div>
      </section>

      {/* ===== EXCHANGE — form + reach ===== */}
      <section className="section band--paper stitch--top">
        <div className="frame">
          <div className="exchange">
            <div>
              <div className="eyebrow-rule">II · Write to us</div>
              <h2 className="exchange__head">Tell us what is going on.</h2>
              <p className="exchange__lede">
                A few lines is enough to start. What is going on, and what you have already tried. We will reply within 24 hours.
              </p>

              <ContactForm />
            </div>

            <div className="exchange__divider" aria-hidden="true"></div>

            <div>
              <div className="eyebrow-rule">III · Reach us</div>
              <h2 className="exchange__head">How to reach us.</h2>
              <p className="exchange__lede">
                If you prefer to contact us directly. Include the same information the form asks for.
              </p>

              <div className="reach__address">
                510 Makou St<br />
                Monument Park<br />
                Pretoria · South Africa
              </div>
              <span className="reach__line">
                <a href="mailto:contact@rslighthouse.com">contact@rslighthouse.com</a>
              </span>
              <span className="reach__line">
                <a href="tel:+27824400939">+27 82 440 0939</a>
              </span>

              <a
                href="https://maps.app.goo.gl/tASpMo7ZKUchX7rYA"
                target="_blank"
                rel="noopener noreferrer"
                className="map-frame"
                style={{ '--map-image': `url(${process.env.PUBLIC_URL || ''}/img/stone_house_map.webp)` }}
                aria-label="Open 510 Makou St, Monument Park in Google Maps"
              >
                <div className="map-pip"></div>
                <div className="map-label">— 510 Makou St · Monument Park</div>
              </a>

              <div className="promise">
                <div className="promise__big">24 hours</div>
                <div className="promise__lbl">— Response time</div>
              </div>

              <div>
                <div className="expect__head">— What to expect</div>
                <ul className="expect__list">
                  {expectations.map((e) => (
                    <li key={e}><span>{e}</span></li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default ContactPage;
